module.exports = __webpack_public_path__ + "static/WEDDING E&M-382-7cc81aa87a8d756efffaf1eef37016e8.jpg";